import { useState, useEffect } from 'react';
import { researchService } from '../services/dataService';

/**
 * Custom hook to fetch research publications from Firestore
 * @returns {Object} { research, loading, error, refetch }
 */
export const useResearch = () => {
  const [research, setResearch] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchResearch = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await researchService.getAll();
      
      if (result.success) {
        // Sort by date (newest first)
        const sortedResearch = result.data.sort((a, b) => {
          const dateA = new Date(a.date || 0);
          const dateB = new Date(b.date || 0);
          return dateB - dateA;
        });
        setResearch(sortedResearch);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResearch();
  }, []);

  return {
    research,
    loading,
    error,
    refetch: fetchResearch
  };
};